// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* KPI Dashboard Styles */

/* View Selector Buttons */
.kpi-view-selector {
  display: flex;
  gap: 10px;
}

.kpi-view-btn {
  padding: 10px 20px;
  border: 2px solid #e0e0e0;
  background-color: var(--color-white);
  border-radius: 8px;
  cursor: pointer;
  transition: all 0.3s ease;
  font-weight: 500;
  color: var(--color-icon-muted);
}

.kpi-view-btn:hover {
  border-color: var(--color-primary-orange);
  color: var(--color-primary-orange);
  background-color: #fff5eb;
}

.kpi-view-btn.active {
  border-color: var(--color-primary-orange);
  background-color: var(--color-primary-orange);
  color: var(--color-white);
}

/* Time Period Filter */
.time-period-filter {
  display: flex;
  gap: 8px;
}

.period-btn {
  padding: 8px 16px;
  border: 1px solid #dee2e6;
  background-color: var(--color-white);
  border-radius: 6px;
  cursor: pointer;
  transition: all 0.2s ease;
  font-size: 14px;
  color: #495057;
}

.period-btn:hover {
  background-color: var(--color-bg-hover);
  border-color: #adb5bd;
}

.period-btn.active {
  background-color: var(--color-primary-green);
  border-color: var(--color-primary-green);
  color: var(--color-white);
}

/* Metric Cards */
.metric-card {
  border: none;
  border-radius: 10px;
  transition: transform 0.2s ease, box-shadow 0.2s ease;
}

.metric-card:hover {
  transform: translateY(-4px);
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15) !important;
}

.metric-title {
  font-size: 13px;
  font-weight: 500;
  text-transform: uppercase;
  letter-spacing: 0.5px;
}

.metric-value {
  font-size: 28px;
  font-weight: 700;
  margin: 8px 0;
}

.metric-subtitle {
  font-size: 12px;
  margin-top: 4px;
}

.metric-icon {
  width: 50px;
  height: 50px;
  border-radius: 10px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 24px;
}

.metric-trend {
  font-size: 13px;
  font-weight: 600;
}

.trend-positive {
  color: #28a745;
}

.trend-negative {
  color: #dc3545;
}

/* Priority Badge */
.priority-badge {
  display: inline-block;
  width: 12px;
  height: 12px;
  border-radius: 50%;
}

/* Status Card */
.status-card {
  background-color: var(--color-bg-hover);
  border-radius: 8px;
  transition: transform 0.2s ease;
}

.status-card:hover {
  transform: scale(1.05);
  background-color: #e9ecef;
}

.status-count {
  font-size: 2rem;
  font-weight: bold;
}

.status-label {
  font-size: 0.875rem;
  text-transform: uppercase;
  letter-spacing: 0.5px;
}

/* Responsive adjustments */
@media (max-width: 768px) {
  .kpi-view-selector {
    flex-direction: column;
  }

  .kpi-view-btn {
    width: 100%;
  }

  .time-period-filter {
    flex-wrap: wrap;
  }

  .period-btn {
    flex: 1 1;
    min-width: 80px;
  }

  .metric-value {
    font-size: 24px;
  }

  .metric-icon {
    width: 40px;
    height: 40px;
    font-size: 20px;
  }
}

/* Table Enhancements */
.table th {
  background-color: var(--color-bg-hover);
  border-bottom: 2px solid #dee2e6;
  font-weight: 600;
  font-size: 14px;
  color: #495057;
}

.table tbody tr:hover {
  background-color: #f1f3f5;
}

/* Progress bars */
.progress {
  background-color: #e9ecef;
}

.progress-bar {
  transition: width 0.6s ease;
}
/* Trend Chart */
.trend-chart {
  height: 240px;            /* ← increase to accommodate rotated labels */
  padding: 10px 0;
}

.chart-bars {
  display: flex;
  align-items: flex-end;
  justify-content: space-between;
  height: 160px;
  gap: 4px;
  border-bottom: 2px solid #dee2e6;
}

.chart-bar-wrapper {
  flex: 1 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-end;   /* ← pushes bar to bottom */
  height: 100%;
}

.chart-bar {
  width: 100%;
  border-radius: 4px 4px 0 0;
  position: relative;
  transition: all 0.3s ease;
  cursor: pointer;
  display: flex;
  align-items: flex-start;
  justify-content: center;
  padding-top: 4px;
  /* no min-height here */
}
.chart-labels {
  display: flex;
  justify-content: space-between;
  gap: 4px;
  margin-top: 4px;
  height: 40px;             /* ← give space for rotated labels */
  overflow: visible;
}
.bar-label {
  flex: 1 1;
  font-size: 9px;
  color: var(--color-icon-muted);
  text-align: center;
  white-space: nowrap;
  overflow: visible;        /* ← allow overflow */
  text-overflow: clip;
  transform: rotate(-45deg);
  transform-origin: top center;
  margin-top: 6px;
}
.icon-orange {
  color: var(--color-primary-orange);
}`, "",{"version":3,"sources":["webpack://./src/containers/ticketing/kpi_dashboard/KPIDashboard.css"],"names":[],"mappings":"AAAA,yBAAyB;;AAEzB,0BAA0B;AAC1B;EACE,aAAa;EACb,SAAS;AACX;;AAEA;EACE,kBAAkB;EAClB,yBAAyB;EACzB,oCAAoC;EACpC,kBAAkB;EAClB,eAAe;EACf,yBAAyB;EACzB,gBAAgB;EAChB,8BAA8B;AAChC;;AAEA;EACE,yCAAyC;EACzC,kCAAkC;EAClC,yBAAyB;AAC3B;;AAEA;EACE,yCAAyC;EACzC,6CAA6C;EAC7C,yBAAyB;AAC3B;;AAEA,uBAAuB;AACvB;EACE,aAAa;EACb,QAAQ;AACV;;AAEA;EACE,iBAAiB;EACjB,yBAAyB;EACzB,oCAAoC;EACpC,kBAAkB;EAClB,eAAe;EACf,yBAAyB;EACzB,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,uCAAuC;EACvC,qBAAqB;AACvB;;AAEA;EACE,4CAA4C;EAC5C,wCAAwC;EACxC,yBAAyB;AAC3B;;AAEA,iBAAiB;AACjB;EACE,YAAY;EACZ,mBAAmB;EACnB,qDAAqD;AACvD;;AAEA;EACE,2BAA2B;EAC3B,qDAAqD;AACvD;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,aAAa;AACf;;AAEA;EACE,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA,mBAAmB;AACnB;EACE,qBAAqB;EACrB,WAAW;EACX,YAAY;EACZ,kBAAkB;AACpB;;AAEA,gBAAgB;AAChB;EACE,uCAAuC;EACvC,kBAAkB;EAClB,+BAA+B;AACjC;;AAEA;EACE,sBAAsB;EACtB,yBAAyB;AAC3B;;AAEA;EACE,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,mBAAmB;EACnB,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA,2BAA2B;AAC3B;EACE;IACE,sBAAsB;EACxB;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,SAAO;IACP,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,WAAW;IACX,YAAY;IACZ,eAAe;EACjB;AACF;;AAEA,uBAAuB;AACvB;EACE,uCAAuC;EACvC,gCAAgC;EAChC,gBAAgB;EAChB,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA,kBAAkB;AAClB;EACE,yBAAyB;AAC3B;;AAEA;EACE,2BAA2B;AAC7B;AACA,gBAAgB;AAChB;EACE,aAAa,aAAa,6CAA6C;EACvE,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,8BAA8B;EAC9B,aAAa;EACb,QAAQ;EACR,gCAAgC;AAClC;;AAEA;EACE,SAAO;EACP,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,yBAAyB,IAAI,2BAA2B;EACxD,YAAY;AACd;;AAEA;EACE,WAAW;EACX,0BAA0B;EAC1B,kBAAkB;EAClB,yBAAyB;EACzB,eAAe;EACf,aAAa;EACb,uBAAuB;EACvB,uBAAuB;EACvB,gBAAgB;EAChB,uBAAuB;AACzB;AACA;EACE,aAAa;EACb,8BAA8B;EAC9B,QAAQ;EACR,eAAe;EACf,YAAY,cAAc,oCAAoC;EAC9D,iBAAiB;AACnB;AACA;EACE,SAAO;EACP,cAAc;EACd,8BAA8B;EAC9B,kBAAkB;EAClB,mBAAmB;EACnB,iBAAiB,SAAS,qBAAqB;EAC/C,mBAAmB;EACnB,yBAAyB;EACzB,4BAA4B;EAC5B,eAAe;AACjB;AACA;EACE,kCAAkC;AACpC","sourcesContent":["/* KPI Dashboard Styles */\n\n/* View Selector Buttons */\n.kpi-view-selector {\n  display: flex;\n  gap: 10px;\n}\n\n.kpi-view-btn {\n  padding: 10px 20px;\n  border: 2px solid #e0e0e0;\n  background-color: var(--color-white);\n  border-radius: 8px;\n  cursor: pointer;\n  transition: all 0.3s ease;\n  font-weight: 500;\n  color: var(--color-icon-muted);\n}\n\n.kpi-view-btn:hover {\n  border-color: var(--color-primary-orange);\n  color: var(--color-primary-orange);\n  background-color: #fff5eb;\n}\n\n.kpi-view-btn.active {\n  border-color: var(--color-primary-orange);\n  background-color: var(--color-primary-orange);\n  color: var(--color-white);\n}\n\n/* Time Period Filter */\n.time-period-filter {\n  display: flex;\n  gap: 8px;\n}\n\n.period-btn {\n  padding: 8px 16px;\n  border: 1px solid #dee2e6;\n  background-color: var(--color-white);\n  border-radius: 6px;\n  cursor: pointer;\n  transition: all 0.2s ease;\n  font-size: 14px;\n  color: #495057;\n}\n\n.period-btn:hover {\n  background-color: var(--color-bg-hover);\n  border-color: #adb5bd;\n}\n\n.period-btn.active {\n  background-color: var(--color-primary-green);\n  border-color: var(--color-primary-green);\n  color: var(--color-white);\n}\n\n/* Metric Cards */\n.metric-card {\n  border: none;\n  border-radius: 10px;\n  transition: transform 0.2s ease, box-shadow 0.2s ease;\n}\n\n.metric-card:hover {\n  transform: translateY(-4px);\n  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15) !important;\n}\n\n.metric-title {\n  font-size: 13px;\n  font-weight: 500;\n  text-transform: uppercase;\n  letter-spacing: 0.5px;\n}\n\n.metric-value {\n  font-size: 28px;\n  font-weight: 700;\n  margin: 8px 0;\n}\n\n.metric-subtitle {\n  font-size: 12px;\n  margin-top: 4px;\n}\n\n.metric-icon {\n  width: 50px;\n  height: 50px;\n  border-radius: 10px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-size: 24px;\n}\n\n.metric-trend {\n  font-size: 13px;\n  font-weight: 600;\n}\n\n.trend-positive {\n  color: #28a745;\n}\n\n.trend-negative {\n  color: #dc3545;\n}\n\n/* Priority Badge */\n.priority-badge {\n  display: inline-block;\n  width: 12px;\n  height: 12px;\n  border-radius: 50%;\n}\n\n/* Status Card */\n.status-card {\n  background-color: var(--color-bg-hover);\n  border-radius: 8px;\n  transition: transform 0.2s ease;\n}\n\n.status-card:hover {\n  transform: scale(1.05);\n  background-color: #e9ecef;\n}\n\n.status-count {\n  font-size: 2rem;\n  font-weight: bold;\n}\n\n.status-label {\n  font-size: 0.875rem;\n  text-transform: uppercase;\n  letter-spacing: 0.5px;\n}\n\n/* Responsive adjustments */\n@media (max-width: 768px) {\n  .kpi-view-selector {\n    flex-direction: column;\n  }\n\n  .kpi-view-btn {\n    width: 100%;\n  }\n\n  .time-period-filter {\n    flex-wrap: wrap;\n  }\n\n  .period-btn {\n    flex: 1;\n    min-width: 80px;\n  }\n\n  .metric-value {\n    font-size: 24px;\n  }\n\n  .metric-icon {\n    width: 40px;\n    height: 40px;\n    font-size: 20px;\n  }\n}\n\n/* Table Enhancements */\n.table th {\n  background-color: var(--color-bg-hover);\n  border-bottom: 2px solid #dee2e6;\n  font-weight: 600;\n  font-size: 14px;\n  color: #495057;\n}\n\n.table tbody tr:hover {\n  background-color: #f1f3f5;\n}\n\n/* Progress bars */\n.progress {\n  background-color: #e9ecef;\n}\n\n.progress-bar {\n  transition: width 0.6s ease;\n}\n/* Trend Chart */\n.trend-chart {\n  height: 240px;            /* ← increase to accommodate rotated labels */\n  padding: 10px 0;\n}\n\n.chart-bars {\n  display: flex;\n  align-items: flex-end;\n  justify-content: space-between;\n  height: 160px;\n  gap: 4px;\n  border-bottom: 2px solid #dee2e6;\n}\n\n.chart-bar-wrapper {\n  flex: 1;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: flex-end;   /* ← pushes bar to bottom */\n  height: 100%;\n}\n\n.chart-bar {\n  width: 100%;\n  border-radius: 4px 4px 0 0;\n  position: relative;\n  transition: all 0.3s ease;\n  cursor: pointer;\n  display: flex;\n  align-items: flex-start;\n  justify-content: center;\n  padding-top: 4px;\n  /* no min-height here */\n}\n.chart-labels {\n  display: flex;\n  justify-content: space-between;\n  gap: 4px;\n  margin-top: 4px;\n  height: 40px;             /* ← give space for rotated labels */\n  overflow: visible;\n}\n.bar-label {\n  flex: 1;\n  font-size: 9px;\n  color: var(--color-icon-muted);\n  text-align: center;\n  white-space: nowrap;\n  overflow: visible;        /* ← allow overflow */\n  text-overflow: clip;\n  transform: rotate(-45deg);\n  transform-origin: top center;\n  margin-top: 6px;\n}\n.icon-orange {\n  color: var(--color-primary-orange);\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
